/* esm.sh - rxjs@7.8.1/dist/esm/internal/observable/concat */
import{concatAll as r}from"../operators/concatAll.mjs";import{popScheduler as t}from"../util/args.mjs";import{from as m}from"./from.mjs";function n(...o){return r()(m(o,t(o)))}export{n as concat};
//# sourceMappingURL=concat.mjs.map